import { createStyles, getStylesRef } from "@mantine/core";

export const horizontalBarStyles = createStyles((theme) => ({
  horizontalBar: {
    position: "sticky",
    minHeight: "auto",
    display: "flex",
    top: "10px",
    width: "100%",
    zIndex: 99,
    marginBottom: "20px",
    flexDirection: "row",
    alignContent: "center",
    alignItems: "center",
    padding: "0.75rem 1rem",
    transition: "all 0.5s linear",
  },
  sticked: {
    boxShadow: `${
      theme.colorScheme === "dark"
        ? "rgb(37 38 43 / 10%) 0rem 0rem 0.0625rem 0.0625rem inset, rgb(0 0 0 / 5%) 0rem 1.25rem 1.6875rem 0rem"
        : "rgb(255 255 255 / 10%) 0rem 0rem 0.0625rem 0.0625rem inset, rgb(0 0 0 / 5%) 0rem 1.25rem 1.6875rem 0rem;"
    }`,
    backdropFilter: "saturate(200%) blur(1.875rem)",
    backgroundColor: `${
      theme.colorScheme === "dark"
        ? "rgba(37,38,43, 0.8)"
        : "rgb(255 255 255 / 49%);"
    }`,
    borderRadius: "15px",
  },
  toggleSideBar: {
    cursor: "pointer",
    padding: "0px 3rem",
    opacity: "0.4",
    position: "relative",
    color: theme.colorScheme === "dark" ? "#DEDEDE" : "rgb(52, 71, 103)",
  },
  iconAddorment: {
    ref: getStylesRef("iconAddorment"),
    display: "none",
    transition: "all 0.50s linear",
    background: "${({ theme }) => theme.body}",
    width: "12px",
    height: "12px",
    position: "absolute",
    left: "52%",
    top: "6px",
    transform: "rotate(45deg)",
    backgroundColor:
      theme.colorScheme === "dark"
        ? theme.colors.gray[0]
        : theme.colors.gray[0],
    "&:before": {
      backgroundColor:
        theme.colorScheme === "dark"
          ? theme.colors.gray[0]
          : theme.colors.gray[0],
      content: '""',
      width: "90%",
      left: "2px",
      top: "-2px",
      height: "90%",
      position: "absolute",
      borderLeft: `solid 3px ${
        theme.colorScheme === "dark" ? "#FCFCFC" : "#121b49"
      }`,
      borderBottom: `solid 3px ${
        theme.colorScheme === "dark" ? "#FCFCFC" : "#121b49"
      }`,
    },
  },
  toggled: {
    [`& .${getStylesRef("iconAddorment")}`]: { display: "block" },
  },
  path: {
    margin: "0px",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontSize: "0.875rem",
    letterSpacing: "0.02857em",
    opacity: "0.5",
    textTransform: "capitalize",
    verticalAlign: "unset",
    textDecoration: "none",
    fontWeight: "normal",
    lineHeight: "0",
  },
  title: {
    fontWeight: "bold",
    color: theme.colorScheme === "dark" ? "#DEDEDE" : "rgb(52, 71, 103)",
    lineHeight: "250%",
  },

  svg: {
    ref: getStylesRef("svg"),
  },
  optionsBar: {
    [`& .${getStylesRef("svg")}`]: {
      cursor: "pointer",
      marginLeft: "15px",
    },
    color: theme.colorScheme === "dark" ? "#DEDEDE" : "rgb(52, 71, 103)",
    marginLeft: "auto",
    opacity: "0.65",
  },
}));
